import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskWorkforcePermissionsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-workforce-permissions',
	path: '/jira/servicedesk/projects/:projectKey/settings/workforce/permissions',
	exact: true,
};
